var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$attrs.loading)?_c('v-skeleton-loader',_vm._b({},'v-skeleton-loader',_vm.$attrs,false)):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }